import _ from 'lodash';
export const name = 'PRIORITY.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const cellValue = _.get(row, prop);
    const tags = _.map(cellValue, (content) => {
        // @ts-ignore
        return <span domProps={{ innerHTML: _highlightMixin_hlText(content) }}/>;
    });
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name}>
            {tags}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const result = _.map(row[column.property] || [], item => {
        return item;
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
